import { useRoutes } from 'react-router-dom';
import { NOT_FOUND, PROTECTED_ROUTES, PUBLIC_ROUTES, RouteType } from './routes';
import { useAppSelector } from 'app/hooks';
import { SplashScreen } from 'pages';
import { FC } from 'react';

const Routes: FC = () => {
    const {
        userInfo: { isLoggedIn },
        splashLoading,
    } = useAppSelector((state) => state.auth);

    const ROUTES: RouteType[] = isLoggedIn ? PROTECTED_ROUTES : PUBLIC_ROUTES;
    const routes = useRoutes([...ROUTES, ...NOT_FOUND]);

    return splashLoading ? <SplashScreen /> : routes;
};

export default Routes;
